const BASE = process.env.REACT_APP_API_BASE || 'https://d365-hkh7chdadngrcye0.eastus-01.azurewebsites.net/api';
const FUNC_KEY = process.env.REACT_APP_FUNCTION_KEY;
const DEFAULT_TIMEOUT = 15000;

function withKey(url) {
  if (!FUNC_KEY) return url;
  return url + (url.includes('?') ? '&' : '?') + `code=${FUNC_KEY}`;
}

async function fetchWithTimeout(url, options = {}, timeout = DEFAULT_TIMEOUT) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (err) {
    if (err.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    throw err;
  } finally {
    clearTimeout(id);
  }
}

async function fetchJSON(url, options = {}, timeout = DEFAULT_TIMEOUT) {
  const res = await fetchWithTimeout(url, options, timeout);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText} ${text}`);
  }
  if (res.status === 204) return null;
  try {
    return await res.json();
  } catch (e) {
    const text = await res.text().catch(() => '');
    throw new Error(`Invalid JSON response: ${text}`);
  }
}

export async function list(entity) {
  return fetchJSON(withKey(`${BASE}/${entity}`));
}

export async function get(entity, id) {
  return fetchJSON(withKey(`${BASE}/${entity}/${id}`));
}

export async function create(entity, payload) {
  return fetchJSON(withKey(`${BASE}/${entity}`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function update(entity, id, payload) {
  const url = withKey(`${BASE}/${entity}/${id}`);
  const res = await fetchWithTimeout(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (res.ok) {
    if (res.status === 204) return null;
    try {
      return await res.json();
    } catch (_err) {
      return null;
    }
  }
  // If the function doesn't expose a PUT route (404), try POST as an upsert fallback
  if (res.status === 404) {
    return fetchJSON(withKey(`${BASE}/${entity}`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  }
  const text = await res.text().catch(()=>'');
  throw new Error(`${res.status} ${res.statusText} ${text}`);
}

export async function remove(entity, id) {
  return fetchJSON(withKey(`${BASE}/${entity}/${id}`), { method: 'DELETE' });
}

const api = { BASE, list, get, create, update, remove };

export default api;
